/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import { observable, action, ObservableMap, toJS } from 'mobx';
import map from 'lodash/map';

class FiltersStore {
    @observable filters = new ObservableMap();
    @observable sorts = new ObservableMap();

    @action
    reset = () => {
        this.filters.clear();
    };

    @action
    setFilter = (key, value) => {
        this.filters.set(key, value);
    };

    @action
    setSort = (key, value) => {
        this.sorts.set(key, value);
    };

    getFilter = key => {
        return toJS(this.filters.get(key) || {});
    };

    getSort = key => {
        return toJS(this.sorts.get(key) || {});
    };

    getFormattedParams = key => {
        const filters = this.getFilter(key);
        const sort = this.getSort(key);
        const res = {};

        map(filters, (value, filterName) => {
            if (value !== false) res[`filterBy-${filterName}`] = value;
        });

        if (sort && sort.value && sort.order && sort.value !== false) {
            if (sort.order === 'asc') {
                res.sortByAsc = sort.value;
            } else {
                res.sortByDesc = sort.value;
            }
        }
        return res;
    };
}

export default new FiltersStore();
